/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Settings_Sub_Active_UntilInputs */

const en_settings_sub_active_until = /** @type {(inputs: Settings_Sub_Active_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan} · active until ${i?.date}`)
};

const id_settings_sub_active_until = /** @type {(inputs: Settings_Sub_Active_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan} · aktif sampai ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{plan} · active until {date}" |
*
* @param {Settings_Sub_Active_UntilInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_active_until = /** @type {((inputs: Settings_Sub_Active_UntilInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_Active_UntilInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_active_until(inputs)
	return en_settings_sub_active_until(inputs)
});